// extracted by mini-css-extract-plugin
module.exports = {"root":"IconPercentage_root__285Fh"};